import * as React from 'react';
export const mastercardSvg = React.forwardRef(function mastercardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E6EBF1',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Zm-1 0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EB001B',
        d: 'M8 4.535A3.998 3.998 0 0 0 6 8c0 1.48.804 2.773 2 3.465a4 4 0 1 1 0-6.93Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F79E1B',
        d: 'M8 11.465A3.998 3.998 0 0 0 10 8c0-1.48-.804-2.773-2-3.465a4 4 0 1 1 0 6.93Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FF5F00',
        d: 'M8 11.465A3.998 3.998 0 0 1 6 8c0-1.48.804-2.773 2-3.465C9.196 5.227 10 6.52 10 8c0 1.48-.804 2.773-2 3.465Z',
      }),
    ),
  );
});
mastercardSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var mastercard = {
  category: 'card',
  colorable: false,
  name: 'mastercard',
  svg: mastercardSvg,
};
